import { Button } from 'antd';
import styled from 'styled-components';

export const ErrorSection = styled(`section`)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100vh;
`;

export const ErrorHeading = styled(`h1`)`
	margin: 0;
	margin-bottom: 24px;
	font-weight: 600;
	font-size: 38px;
`;
export const ErrorText = styled(`p`)`
	margin: 0;
	margin-bottom: 36px;
	font-size: 16px;
`;
export const ErrorImg = styled(`img`)`
	margin-bottom: 48px;
	width: 385px;
	height: 375px;
`;

export const ButtonStyled = styled(Button)`
	border-radius: 2px;
`;
